module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dy-item-wrap', {
    attrs: {
      "item": _vm.item
    }
  }, [_c('el-checkbox-group', _vm._g(_vm._b({}, 'el-checkbox-group', _vm.$attrs, false), _vm.$listeners), _vm._l((_vm.item.options), function(o) {
    return _c(_vm.item.button ? 'el-checkbox-button' : 'el-checkbox', {
      key: o.value,
      tag: "component",
      attrs: {
        "disabled": o.disabled,
        "label": o.value,
        "border": _vm.item.border
      }
    }, [_vm._v(_vm._s(o.label))])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a85bd356"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/widgets/CheckboxWidget.vue
// module id = 726
// module chunks = 20